import React from 'react'
import { getActiveAccount } from 'preferences/selectors'
import { useAppSelector } from 'store/hooks'
import { PageTitle } from 'uiComponents/typography'
import { getHash, getHashParam, setHash } from 'utils/hash'
import { AddDiscountModal } from './addDiscount'
import { AddPoolModal } from './addPool'
import { DeletePoolModal } from './deletePool'
import { DiscountsHeader } from './discountsHeader'
import { EditDiscountModal } from './editDiscount'
import { RedeemCodes } from './codes'
import './discounts.scss'
import { useTranslation } from 'translations'

export const Discounts: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { t } = useTranslation()
    const accountSlug = useAppSelector(getActiveAccount)
    const poolUuid = getHashParam('poolUuid')
    const codeUuid = getHashParam('codeUuid')
    const codeType = getHashParam('codeType') as 'upload' | 'code' | undefined
    const hash = getHash()

    return (
        <>
            <PageTitle>{t('discounts.discounts.pageTitle')}</PageTitle>
            <DiscountsHeader
                onClickNewDiscount={() => {
                    setHash('add_discount')
                }}
                onClickNewDiscountPool={() => setHash('add_discount_pool')}
            />
            <div id="discounts-table-container">{children}</div>
            <div className="discount-modals">
                {hash.route === 'add_discount' && <AddDiscountModal selectedPoolUuid={poolUuid} />}
                {hash.route === 'add_discount_pool' && <AddPoolModal />}
                {hash.route === 'delete_pool' && poolUuid && <DeletePoolModal poolUuid={poolUuid} />}
                {hash.route === 'edit_discount' && codeUuid && poolUuid && accountSlug && (
                    <EditDiscountModal codeUuid={codeUuid} poolUuid={poolUuid} accountSlug={accountSlug} />
                )}
            </div>
            {hash.route === 'redeem_unused_codes' && codeUuid && codeType && ['upload', 'code'].includes(codeType) && (
                <RedeemCodes codeUuid={codeUuid} codeType={codeType} />
            )}
        </>
    )
}
